// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import etask from 'zetask';
import cn from 'classnames';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_x_close from '../../../../hola/pub/img/hola2023/icons/16/x_close.svg';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_copy from '../../img/icons/16/Copy.svg';
import Icon_link from '../../img/icons/16/link2.svg';
import {Btn_loader} from './btn_loader';
import {use_disappear} from '../../../../toolip/pub/ui/dashboard/utils';
import {Modal} from '../../../../hola/pub/lib/modal';
import {use_screen} from '../../../../hola/pub/lib/screen_util';

import styles from '../../pages/toolip.io/dashboard.module.less';

interface i_confirm_dialog_props {
    on_confirm: ()=>void;
    close: ()=>void;
    is_open: boolean
    title: string
    sub_title?: string
    caption_cancel: string | JSX.Element
    caption_confirm: string | JSX.Element
}
export const Confirmation_dialog = (props: i_confirm_dialog_props)=>{
  const {theme} = useContext(Settings_context);
  const confirm = ()=>etask(function*(){
      yield props.on_confirm();
  });
  const {width} = use_screen();
  return <Modal lighter_close_btn={true} is_open={props.is_open}
    low_dim on_close={props.close} width={width >= 768 ? 417 : 335}
    cls={styles.refresh_token_modal} paddingless
    on_overlay_click={ev=>{
      props.close();
      ev.stopPropagation();
    }}>
      <div className={styles.confirm_modal}>
      <p className={cn(theme.p16, theme.med, theme.color_n700, styles.mb)}>
        {props.title}
      </p>
      {props.sub_title &&
        <p className={cn(theme.p14, theme.med, theme.color_n600)}>
          {props.sub_title}
        </p>}
      <div className={styles.btn_container}>
        <Button caption={props.caption_cancel} color='transparent'
          on_click={()=>props.close()} round={false}/>
        <Button caption={props.caption_confirm}
          on_click={confirm} round={false}/>
      </div>
    </div>
  </Modal>;
};

export const Api_token_panel = ()=>{
    const {qs, set_qs} = use_qs_with_set();
    const {theme} = useContext(Settings_context);
    const {show_api_token} = qs;
    const [is_confirm_open, set_is_confirm_open] = useState(false);
    const {token, is_busy, err, refresh_token} = use_fetch_token();
    const {visible: visible_copied, show: show_copied} = use_disappear(2);
    const {width} = use_screen();
    const [copy_btn_width, set_copy_btn_width] = useState(0);
    const copy_btn_ref = useRef(null);
    useEffect(()=>{
      if (copy_btn_ref.current)
          set_copy_btn_width(copy_btn_ref.current.offsetWidth);
    }, [copy_btn_ref.current, width]);
    useEffect(()=>{
        document.body.classList[show_api_token?'add':'remove'](
          'hola_modal-no_body_scroll_stack');
    }, [show_api_token]);
    const copy =()=>etask(function*(){
      try {
        yield navigator.clipboard.writeText(token);
        show_copied();
      } catch(e){}
    });
    return <div className={cn(styles.overlay,
      show_api_token && styles.visible)}
      onClick={()=>set_qs({show_api_token: undefined})}>
      <div className={styles.api_token_panel}
        onClick={ev=>ev.stopPropagation()}>
        <div className={styles.wrapper}>
          <div className={styles.header}>
            <p className={cn(theme.p18, theme.med, theme.color_n700)}>
                API token</p>
            <Icon_x_close onClick={()=>{
              set_qs({show_api_token: undefined});
            }} className={styles.close}/>
          </div>
          <p className={cn(theme.p12, styles.text_center)}>
            Secure and manage your API token for seamless integration
          </p>
          {token && <div className={styles.token_container}>
            <p className={cn(theme.p12, theme.color_n400)}>Token</p>
            <div className={styles.token}>
              <span className={theme.mono14}>{token}</span>
              <div ref={copy_btn_ref} className={styles.copy_btn_wrapper}>
                <Button on_click={copy} size='xs' color='black'
                  round={false} caption={<><Icon_copy/>Copy</>}/>
              </div>
            </div>
            <span className={cn(styles.copied,
              visible_copied && styles.visible)}
              style={width < 768 ?
                {right: `calc(100% - 46px - ${copy_btn_width / 2}px)`} : null}>
              Copied!</span>
          </div>}
          <div className={styles.h_line}/>
          {!is_busy && !token &&
            <Button caption={is_busy ? <Btn_loader />: 'Generate token'}
              color='transparent' size='sm' disabled={is_busy} round={false}
              on_click={refresh_token} />}
          {token && <div className={styles.refresh_block}>
            <Button caption={is_busy ? <Btn_loader />: 'Refresh token'}
              color='transparent' size='sm' disabled={is_busy} round={false}
              on_click={()=>set_is_confirm_open(true)} width={130}
              cls={styles.api_token_panel_btn}/>
            <p className={cn(theme.p12, theme.color_n400)}>
              Refreshing the token will permanently erase your current
              API token, and it cannot be used again.</p>
          </div>}
          {err && <p className={cn(styles.error, theme.p16, theme.med)}>
              {err}</p>}
        </div>
        <div className={styles.info_wrapper}>
          <p className={cn(theme.p14, theme.med, styles.mb8)}>
            Ready to integrate the API into your system?</p>
          <p className={cn(theme.p14, styles.mb16)}>
            Our simple, standalone API can be used without the dashboard.
            Visit our docs for step-by-step instructions to implement
            your API token seamlessly.</p>
          <Button color='transparent' size='sm' round={false} width={201}
            to='https://docs.toolip.io/api-reference/introduction'
            target='_blank' caption={<>Visit Documentation<Icon_link/></>}
            cls={styles.api_token_panel_btn}/>
        </div>
      </div>
      <Confirmation_dialog is_open={is_confirm_open}
        caption_cancel='Cancel' caption_confirm='Refresh'
        title='Are you sure you want to proceed?'
        sub_title={`Refreshing the token will permanently erase your
          current API token, and it cannot be used again.`}
        close={()=>set_is_confirm_open(false)}
        on_confirm={()=>{
          refresh_token();
          set_is_confirm_open(false);
        }}/>
    </div>;
};

export const use_fetch_token = (disable?: boolean)=>{
    const [token, set_token] = useState<string|null>(null);
    const [is_busy, set_is_busy] = useState<boolean>(false);
    const [err, set_err] = useState<string|null>(null);
    useEffect(()=>{
      if (disable)
        return;
      fetch_token();
    }, [disable]);
    const call_proxies_api=(is_refresh:boolean)=>etask(function*(){
        set_is_busy(true);
        set_err(null);
        try {
            const url = `/api/proxies/api_token${is_refresh?'/refresh': ''}`;
            const res = yield fetch(url,
                {method: is_refresh ? 'POST' : 'GET'});
            if (res)
                set_token(res?.token ?? null);

            if (res.err)
            {
                set_err(is_refresh
                    ? 'Failed to refresh token': 'Failed to fetch token');
            }
        } catch(e){
            // set_err(e.hola_info?.response_text ?? 'Something went wrong');
            set_err('Something went wrong');
        }
        set_is_busy(false);
    });
    const fetch_token=()=>call_proxies_api(false);
    const refresh_token=()=>call_proxies_api(true);
    return {token, is_busy, err, refresh_token};
};
